import React, { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

const Home = lazy(() => import('@pages/Home'))
const NosActionsRse = lazy(() => import('@pages/NosActionsRse'))
const NosPerformances = lazy(() => import('@pages/NosPerformances'))
const NosChiffresCles = lazy(() => import('@pages/NosChiffresCles'))
const NotrePatrimoine = lazy(() => import('@pages/NotrePatrimoine'))
// const MentionsLegales = lazy(() => import("./views/MentionsLegales"));

const { REACT_APP_MENTIONS } = process.env

const SiteRoutes = () => {
	return (
		<>
			<Routes>
				<Route exact path="/" element={<Home />} />
				<Route path="/nos_actions_rse" element={<NosActionsRse />} />
				<Route path="/nos_performances" element={<NosPerformances />} />
				<Route path="/notre_patrimoine" element={<NotrePatrimoine />} />
				<Route path="/nos_chiffres_cles" element={<NosChiffresCles />} />
				{
					// <Route  path="/mentions_legales" element={<MentionsLegales />}/>
				}
			</Routes>
		</>
	)
}
export default SiteRoutes
